import { Alert, Box, Chip, LinearProgress, Paper, Stack, Typography } from '@mui/material';
import React from 'react';
import { funnelStages } from './pivot';
import { UNMAPPED_REASON_LABELS } from './health';

/**
 * The ingest funnel, with each drop named.
 *
 * Fetching bills is solved and mapping them to a property is not; five raw counts in a row do not
 * say that, and the number people act on is the gap rather than any single stage.
 */
export const Funnel = _ref => {
  var _ingest$unmappedReaso;
  let ingest = _ref.ingest;
  const stages = funnelStages(ingest);
  const worst = stages.reduce((a, b) => b.lost > a.lost ? b : a, stages[0]);
  return /*#__PURE__*/React.createElement(Paper, {
    sx: {
      padding: '16px',
      marginBottom: '16px'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    gutterBottom: true
  }, "From portal to allocation"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    sx: {
      marginBottom: '12px'
    }
  }, "Landing in S3 is the means. Reaching the allocation table is the end."), /*#__PURE__*/React.createElement(Stack, {
    spacing: "10px"
  }, stages.map(stage => /*#__PURE__*/React.createElement(Box, {
    key: stage.label,
    sx: {
      display: 'grid',
      gridTemplateColumns: '190px 1fr 150px',
      gap: '12px',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, stage.label), /*#__PURE__*/React.createElement(LinearProgress, {
    variant: "determinate",
    value: stage.share,
    color: stage.lost && stage.label === worst.label ? 'error' : 'primary',
    sx: {
      height: 10,
      borderRadius: 5
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    sx: {
      fontVariantNumeric: 'tabular-nums'
    }
  }, stage.value.toLocaleString(), stage.lost ? /*#__PURE__*/React.createElement(Typography, {
    component: "span",
    variant: "caption",
    color: "text.secondary"
  }, " (-".concat(stage.lost.toLocaleString(), ")")) : null, stage.queued ? /*#__PURE__*/React.createElement(Typography, {
    component: "span",
    variant: "caption",
    color: "text.secondary"
  }, " (".concat(stage.queued.toLocaleString(), " queued)")) : null)))), worst !== null && worst !== void 0 && worst.lost ? /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    sx: {
      display: 'block',
      marginTop: '12px'
    },
    color: "text.secondary"
  }, "Biggest drop: ".concat(worst.lost.toLocaleString(), " bills lost at \"").concat(worst.label, "\". That is the constraint.")) : null, ingest !== null && ingest !== void 0 && (_ingest$unmappedReaso = ingest.unmappedReasons) !== null && _ingest$unmappedReaso !== void 0 && _ingest$unmappedReaso.length ? /*#__PURE__*/React.createElement(Box, {
    sx: {
      marginTop: '12px'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption"
  }, "Why the rest are unmapped (".concat(ingest.unmapped, " streams)")), /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '8px',
      marginTop: '4px'
    }
  }, ingest.unmappedReasons.map(reason => /*#__PURE__*/React.createElement(Chip, {
    key: reason.reason,
    size: "small",
    label: "".concat(UNMAPPED_REASON_LABELS[reason.reason] || reason.reason, ": ").concat(reason.count)
  })))) : null, !(ingest !== null && ingest !== void 0 && ingest.posted) ? /*#__PURE__*/React.createElement(Alert, {
    severity: "info",
    sx: {
      marginTop: '12px'
    }
  }, "No bill has been sent to the app yet.".concat(ingest !== null && ingest !== void 0 && ingest.pending ? " ".concat(ingest.pending.toLocaleString(), " are mapped and queued rather than lost.") : '').concat(worst !== null && worst !== void 0 && worst.lost ? " The largest drop is at \"".concat(worst.label, "\", which is where to look first.") : '').concat(worst !== null && worst !== void 0 && worst.lost && worst.label === 'Mapped to a property' ? ' A stream needs a property address in the credential tracker to be mapped.' : '')) : null);
};